import { useState } from "react";

import { api_without_cancellation } from "@/api/api";

const useLibrary = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateDocument = async ({ document_id, tags, is_available_for_copilot }) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api_without_cancellation.post("/api/document-library/documents/", {
        document_id,
        tags,
        is_available_for_copilot,
      });
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { updateDocument, loading, error };
};

export default useLibrary;
